import { LoadingWrapper } from "@components";
import { useAutomation } from "@services";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import AutomationStep2 from "./components/AutomationTable";
import EmptyState from "./components/EmptyState";
import AutomationStep1 from "./onboarding/AutomationOnboarding";

const Automation = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const [step, setStep] = useState<{
    showOnBoarding: boolean;
    showTable: boolean;
  }>({
    showOnBoarding: false,
    showTable: false,
  });
  const { GetOnboardingQuery, GetListingManagmentQuery } = useAutomation();
  /*----------------------
  Queries 
-----------------------*/
  const { data, isLoading, refetch, isRefetching } = GetOnboardingQuery();
  const { data: listingData, isLoading: listLoading } =
    GetListingManagmentQuery({
      pageSize: 5,
      pageNumber: 1,
    });
  /*----------------------
  UseEffects 
-----------------------*/
  useEffect(() => {
    refetch();
  }, []);
  useEffect(() => {
    if (data && data?.result && data?.result?.isOnBoardingComplete) {
      setStep({
        showOnBoarding: false,
        showTable: true,
      });
    } else {
      setStep({
        showOnBoarding: true,
        showTable: false,
      });
    }
  }, [data]);

  if (listLoading || isLoading || isRefetching) {
    return (
      <LoadingWrapper
        children={<div style={{ height: "100vh" }}></div>}
        loading
      />
    );
  }

  if (listingData?.result?.length === 0 && !listLoading) {
    return <EmptyState />;
  }

  return (
    <>
      {/* <AutomationStep1 />{" "} */}
      <LoadingWrapper loading={isLoading}>
        <section
          style={{
            display: step.showOnBoarding ? "block" : "none",
          }}
        >
          <AutomationStep1
            state={() => {
              setStep({
                showOnBoarding: false,
                showTable: true,
              });
            }}
          />
        </section>
        <section
          style={{
            display: step.showTable == true ? "block" : "none",
          }}
        >
          <AutomationStep2 /> 
        </section>
      </LoadingWrapper>
    </>
  );
};

export default Automation;
